module.exports = __webpack_public_path__ + "img/cegtuning.f30e6f79.jpg";